import styled from "styled-components";
import { Card, Cards, CardDownLoadBtn, CardContainer } from "./CommonComponents";
import { StepCircle } from "./svgs";
import contents from "../utills/page_contents.json";
import { downloadGuideFile } from "../api/api";

const Line = styled.div`
  position: absolute;
  top: 30%;
  right: 0px;
  width: 2px;
  height: 70%;
  background-color: rgba(255, 255, 255, 0.3);
`;

function GuideCard() {
  const {guide_steps} = contents;
  return (
    <CardContainer id="guideCard">
      <Cards grid_childs_number={guide_steps.length}>
        {guide_steps.map((step, index) => (
          <Card key={step.title} index={index} id={`price_card${index}`}>
            <StepCircle step={index + 1} />
            <h1>{step.title}</h1>
            <span>{step.description}</span>
            {index + 1 !== guide_steps.length ? <Line /> : null}
          </Card>
        ))}
      </Cards>
              <CardDownLoadBtn onClick={downloadGuideFile}>
                Download Guide
              </CardDownLoadBtn>
    </CardContainer>
  );
}

export default GuideCard;
